var { Sidechain } = require("@nprapps/sidechain");
Sidechain.registerGuest();

// build our custom D3 object
var d3 = {
  ...require("d3-scale/dist/d3-scale.min")
};

var { COLORS, classify } = require("./lib/helpers");
var { isMobile } = require("./lib/breakpoints");
var $ = require("./lib/qsa");
var template = $.one("#map-template");

// Global vars

// Initialize the graphic.
var onWindowLoaded = function () {
  formatData();
  render();

  window.addEventListener("resize", render);
};

// Format graphic data.
var formatData = function () {
  if (!LABELS.show_territories) {
    var territories = ["Puerto Rico", "U.S. Virgin Islands", "Guam", "Northern Mariana Islands", "American Samoa"];

    DATA = DATA.filter((d) => territories.indexOf(d.state_name) == -1);
  }
};

// Render the graphic(s).
var render = function () {
  var elements = $(".map-container");

  for (var element of elements) {
    // Render the map!
    var width = element.offsetWidth;
    renderStateGridMap({
      element,
      width,
      data: DATA
    });
  }

};

// Render a state grid map.
var renderStateGridMap = function (config) {
  var valueColumn = config.element.dataset.category;

  // Clear existing graphic (for redraw)
  var containerElement = config.element;
  containerElement.innerHTML = "";

  // Copy map template
  containerElement.append(template.content.cloneNode(true));

  // Select SVG element
  var chartElement = containerElement.querySelector("svg");

  // Set state colors
  config.data.forEach(function (state) {
    if (state[valueColumn] !== null && state[valueColumn] !== undefined) {
      var stateClass = "state-" + classify(state.state_name);
      var categoryClass = "category-" + classify(state[valueColumn] + "");

      var selected = chartElement.querySelector("." + stateClass);
      selected.setAttribute("class", `${stateClass} ${categoryClass}`);
    }
  });

  var ns = chartElement.namespaceURI;
  var labelGroup = document.createElementNS(ns, "g");
  chartElement.append(labelGroup);
  for (var d of config.data) {
    var state = STATES.find(s => s.name == d.state_name);
    var text = document.createElementNS(ns, "text");
    text.setAttribute("text-anchor", "middle");
    text.textContent = state.usps;
    labelGroup.append(text);
    if (valueColumn in d) {
      text.setAttribute("class", `category-${classify(d[valueColumn] + "")} label label-active`);
    } else {
      text.setAttribute("class", "label");
    }
    var box = chartElement.querySelector(`.state-${classify(state.name)}`);
    var boxBounds = box.getBBox();
    var textBounds = text.getBBox();
    text.setAttribute("x", boxBounds.x + boxBounds.width * .5 + .52);
    text.setAttribute("y", boxBounds.y + boxBounds.width * .5 + textBounds.height * .6);
  }
};

// Initially load the graphic
// (NB: Use window.load to ensure all images have loaded)
window.onload = onWindowLoaded;
